import { render, staticRenderFns } from "./AlarmStatis.vue?vue&type=template&id=32edc11b&scoped=true&"
import script from "./AlarmStatis.vue?vue&type=script&lang=js&"
export * from "./AlarmStatis.vue?vue&type=script&lang=js&"
import style0 from "./AlarmStatis.vue?vue&type=style&index=0&id=32edc11b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32edc11b",
  null
  
)

export default component.exports